(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community-infinite-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCommunityCarousels() {
      var sections = document.querySelectorAll('.community-carousel');

      sections.forEach(function (section) {
        var track = section.querySelector('.community-carousel__track');
        var primaryGroup = section.querySelector('[data-carousel-group="primary"]');
        if (!track || !primaryGroup) return;

        var measure = function () {
          // Exact pixel width of ONE group (including its own trailing gap),
          // so translating the track by exactly this many px lines the
          // second (cloned) group up perfectly with no snap/stop — this is
          // what fixes the iOS Safari looping bug.
          var width = primaryGroup.getBoundingClientRect().width;
          if (width > 0) {
            track.style.setProperty('--carousel-distance', width + 'px');
          }
        };

        // Measure once fonts/images are laid out, and again after each
        // image finishes loading (widths can shift slightly as responsive
        // images swap sources), plus on resize / orientation change.
        measure();
        window.requestAnimationFrame(measure);

        var images = primaryGroup.querySelectorAll('img');
        images.forEach(function (img) {
          if (img.complete) return;
          img.addEventListener('load', measure, { once: true });
        });

        var resizeObserver = window.ResizeObserver
          ? new ResizeObserver(function () {
              measure();
            })
          : null;

        if (resizeObserver) {
          resizeObserver.observe(primaryGroup);
        } else {
          window.addEventListener('resize', measure);
          window.addEventListener('orientationchange', measure);
        }

        // iOS Safari occasionally leaves a CSS animation "stuck" after the
        // tab/app is backgrounded and returns to the foreground. Nudging
        // the animation on visibility change keeps it running smoothly.
        document.addEventListener('visibilitychange', function () {
          if (document.visibilityState === 'visible') {
            track.style.animation = 'none';
            // Force reflow before re-enabling the animation.
            void track.offsetHeight;
            track.style.animation = '';
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCommunityCarousels);
    } else {
      initCommunityCarousels();
    }

    // Re-init when the section is added/edited live in the theme editor.
    document.addEventListener('shopify:section:load', initCommunityCarousels);
  })();

  } catch(e) { console.error(e); }
})();
})();
